export const NOTIFICATIONS = 'NOTIFICATIONS';
export const GROUP_OVERVIEW = 'GROUP_OVERVIEW';
export const PROFILES_DIRECTORY = 'PROFILES_DIRECTORY';
